export const GET_RECHECKING_RECORDS = 'GET_RECHECKING_RECORDS'
export const GET_RECHECKING_RECORD_OPTIONS = 'GET_RECHECKING_RECORD_OPTIONS'
export const GET_STUDENT_RECHECKING_RECORD = 'GET_STUDENT_RECHECKING_RECORD'
export const SAVE_STUDENT_RECHECKING_RECORD = 'SAVE_STUDENT_RECHECKING_RECORD'
export const APPROVE_RECHECKING_RECORDS = 'APPROVE_RECHECKING_RECORDS'
export const DELETE_RECHECKING_RECORD = 'DELETE_RECHECKING_RECORD'
export const EXPORT_RECHECKING_RECORDS = 'EXPORT_RECHECKING_RECORDS'

export const GET_RECHECKING_EAR_SERVICES = 'GET_RECHECKING_EAR_SERVICES'
export const CREATE_EAR_SERVICE = 'CREATE_EAR_SERVICE'
export const UPDATE_EAR_SERVICE = 'UPDATE_EAR_SERVICE'
export const DELETE_EAR_SERVICE = 'DELETE_EAR_SERVICE'
export const DELETE_MANY_EAR_SERVICES = 'DELETE_MANY_EAR_SERVICES'
